import { useQuery } from '@tanstack/react-query';
import {
  PaymentMethodsApiAdapter,
  PaymentMethod,
} from '../adapters/PaymentMethodsApiAdapter';

export const usePaymentMethods = () => {
  const paymentMethodsAdapter = new PaymentMethodsApiAdapter();

  const {
    data: paymentMethods,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['paymentMethods'],
    queryFn: () => paymentMethodsAdapter.getPaymentMethods(),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    paymentMethods: paymentMethods || [],
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
